import React, {useState} from 'react';
import {FormattedMessage} from 'react-intl';
import {can} from '../../../_common/components/Permissions';
import {permissionTypes as T, subjects as S} from '../../../_common/constants/permissionSubjects';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import {tooltips as TTS} from '../../../_common/constants/tooltips';
import {PopupEditTotalPaymentContextProvider} from './PopupEditTotalPaymentContext';
import PopupEditTotalPaymentForm from './PopupEditTotalPaymentForm';
import ButtonAction from '../../../_common/components/ButtonAction';
import ModalContainer from '../../../_common/components/ModalContainer';
import ModalHeader from '../../../_common/components/ModalHeader';

const PopupEditTotalPayment = ({orderID, totalPayment}) => {
  const [show, setShow] = useState(false);
  const handleCloseModal = () => setShow(false);
  const handleShowModal = () => setShow(true);

  return (
    <>
      <ButtonAction
        variant={'icon'}
        iconButtonType={'primary'}
        label={<img src={toAbsoluteUrl('media/common/Edit_primary.svg')} alt="edit"/>}
        title={TTS.EDIT_PAYMENT}
        disabled={!can(T.FULL, S.ORDERS_PAGE)}
        onClick={handleShowModal}
        customClassnames={'mr-4'}
      />
      <ModalContainer show={show} onClose={handleCloseModal} size={'md'}>
        <ModalHeader
          header={ <FormattedMessage
            id={'orders-page-edit-totalPayment'} defaultMessage={'Edit total payment'}
            values={{orderID}}
          />}
        />
        <PopupEditTotalPaymentContextProvider
          orderID={orderID}
          totalPayment={totalPayment}
          handleCloseModal={handleCloseModal}
        >
          <PopupEditTotalPaymentForm/>
        </PopupEditTotalPaymentContextProvider>
      </ModalContainer>
    </>
  );
};

export default PopupEditTotalPayment;